import React, { useRef } from 'react';

import { useGetSearchTerm } from '../../../../shared/hooks/use-get-search-term/use-get-search-term.hook';
import { getFirmwaresWithPagination } from '../../../../shared/thunks/get-firmwares-with-pagination/get-firmwares-with-pagination.thunk';
import { FIRMWARE } from '../../../../store/utils/files-names';
import SearchBar from '../../../shared/components/search-bar/SearchBar';
import { useClearText } from '../../../shared/components/search-bar/hooks/use-clear-text/use-clear-text.hook';
import SetIsCheckedContextProvider from '../../../shared/components/ui/Table/components/table/context/set-is-checked/set-is-checked.context';
import { useInputHandlerEvent } from '../../../shared/hooks/use-input-event-handler/use-input-event-handler.hook';
import { useSearchHandlerEvent } from '../../../shared/hooks/use-search-event-handler/use-search-event-handler.hook';
import { useToggleFiltersVisibility } from '../../../shared/hooks/use-toggle-filters-visibility/use-toggle-filters-visibility.hook';
import { useAreFirmwaresFiltersVisible } from '../../hooks/use-are-firmwares-filters-visible/use-are-firmwares-filters-visible.hook';
import { FirmwareFilters } from '../../models/firmware-filters.model';
import {
  filterFirmwaresByName,
  firmwareToggleFiltersVisibility,
} from '../../store/slices/firmware.slice';
import FirmwareTable from '../FirmwareTable/FirmwareTable';
import FirmwareFilter from '../firmware-filter/firmware-filter';

const Firmware = (): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null);
  const clearText = useClearText(inputRef, filterFirmwaresByName, 'name');

  const firmwaresSearchTerm = useGetSearchTerm(FIRMWARE, 'name');
  const areFiltersVisible = useAreFirmwaresFiltersVisible();
  const toggleFiltersVisibility = useToggleFiltersVisibility(
    firmwareToggleFiltersVisibility
  );

  const handleInputEvent = useInputHandlerEvent<FirmwareFilters>(
    'name',
    filterFirmwaresByName
  );

  const handleSearchEvent = useSearchHandlerEvent(
    getFirmwaresWithPagination,
    FIRMWARE
  );

  return (
    <>
      <SearchBar
        createRoutePath="/firmware-management/create"
        searchInputPlaceholder="Firmware Name"
        filterButtonClickHandler={toggleFiltersVisibility}
        searchInputChangeHandler={handleInputEvent}
        searchOnSubmitHandler={handleSearchEvent}
        inputRef={inputRef}
        clearText={clearText}
        areFiltersVisible={areFiltersVisible}
        initialValue={firmwaresSearchTerm}
      />

      {areFiltersVisible && <FirmwareFilter />}
      <SetIsCheckedContextProvider>
        <FirmwareTable />
      </SetIsCheckedContextProvider>
    </>
  );
};

export default Firmware;
